import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthWithImageEmailSent() {
	return <AuthShell variant="with-image"><AuthForm variant="with-image" mode="email-sent" /></AuthShell>;
}

export default AuthWithImageEmailSent;
